module.exports = __webpack_public_path__ + "img/9-4_Filter_Latent_Linear_2.97fec7d9.png";